__turbopack_context__.v({
  "checkbox": "questionAlerts-module-scss-module__x6VmkG__checkbox",
  "dailyTimeCheckbox": "questionAlerts-module-scss-module__x6VmkG__dailyTimeCheckbox",
  "dayWeek": "questionAlerts-module-scss-module__x6VmkG__dayWeek",
  "footer": "questionAlerts-module-scss-module__x6VmkG__footer",
  "inlineBlock": "questionAlerts-module-scss-module__x6VmkG__inlineBlock",
  "itemAlerts": "questionAlerts-module-scss-module__x6VmkG__itemAlerts",
  "selectDaysOfWeek": "questionAlerts-module-scss-module__x6VmkG__selectDaysOfWeek",
  "strong": "questionAlerts-module-scss-module__x6VmkG__strong",
  "timeSelect": "questionAlerts-module-scss-module__x6VmkG__timeSelect",
  "wrpSelect": "questionAlerts-module-scss-module__x6VmkG__wrpSelect",
});
